import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import MopayForm from '../../components/forms/MopayForm/MopayForm';

const MopayPayment = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="mopay-momo">
      <MopayForm userId={uid} />
    </AuthLayout>
  );
};

export default MopayPayment;
